import { render } from "./SignSaleForTen.vue?vue&type=template&id=095d8a7a&scoped=true"
import script from "./SignSaleForTen.vue?vue&type=script&lang=js"
export * from "./SignSaleForTen.vue?vue&type=script&lang=js"

import "./SignSaleForTen.vue?vue&type=style&index=0&id=095d8a7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095d8a7a"]])

export default __exports__